if (!customElements.get('xo-deferred-external-video')) {
  class XoDeferredExternalVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.querySelector('button')?.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.loadPlayer();
        },
        { once: true },
      );
    }

    loadPlayer() {
      const template = this.querySelector('template');
      if (!template) return;

      this.replaceChildren(template.content.cloneNode(true));
      requestAnimationFrame(() => this.querySelector('iframe')?.focus());
    }
  }

  customElements.define('xo-deferred-external-video', XoDeferredExternalVideo);
}
